/**
 * sendingSummary.ts — pure helpers for the per-user sending-domain notice.
 * Kept free of React / context imports so they can be unit-tested directly.
 */
import type { SendingContext } from "@/types/common";

/** Title per notice_code returned by GET /api/v1/mailbridge/sending-context. */
export const NOTICE_TITLE: Record<string, string> = {
  domain_not_registered: "Your Mailbox Domain Is Not Registered",
  subdomain_not_registered: "Your Mailbox Subdomain Is Not Registered",
  no_mailbox: "No Mailbox Connected",
  mailbox_unknown: "Sending Mailbox Could Not Be Confirmed",
};

/** Domain usage line, e.g. "newco.com · Warm-Up Week 1 · 4 / 10 Today". */
export function sendingSummaryText(
  ctx: Pick<
    SendingContext,
    "domain_name" | "warming_week" | "domain_daily_cap" | "domain_sent_today"
  >,
): string | null {
  if (!ctx.domain_name) return null;
  const parts = [ctx.domain_name];
  if (ctx.warming_week && ctx.warming_week >= 1 && ctx.warming_week < 7) {
    parts.push(`Warm-Up Week ${ctx.warming_week}`);
  } else if (ctx.warming_week === 7) {
    parts.push("Fully Warm");
  }
  if (ctx.domain_daily_cap != null && ctx.domain_sent_today != null) {
    parts.push(`${ctx.domain_sent_today} / ${ctx.domain_daily_cap} Today`);
  }
  return parts.join(" · ");
}
